
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface HeroProps {
  title: string;
  subtitle?: string;
  buttonText?: string;
  buttonLink?: string;
  bgColor?: string;
}

const Hero = ({ 
  title, 
  subtitle, 
  buttonText = "Alusta muutust", 
  buttonLink = "/contact",
  bgColor = "bg-gradient-to-r from-kaija-peach to-kaija-light" 
}: HeroProps) => {
  return (
    <div className={`${bgColor} py-16 md:py-24`}>
      <div className="container-custom text-center">
        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 max-w-3xl mx-auto">
          {title}
        </h1>
        
        {subtitle && (
          <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-2xl mx-auto">
            {subtitle}
          </p>
        )}
        
        {buttonText && (
          <Button asChild className="bg-kaija-slate hover:bg-opacity-90 text-white px-8 py-3 rounded-md">
            <Link to={buttonLink}>
              {buttonText}
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
};

export default Hero;
